import React, { useContext, useState, useEffect } from "react";
import AlertContext from "../../context/alert/AlertContext";
import { useLocation } from "react-router-dom";

const Alerts = () => {
  const alertContext = useContext(AlertContext);
  let [targetAlert, setTargetAlert] = useState(true);
  let [alertShown, setAlertShown] = useState(false);
  const { clearAlerts } = alertContext;
  // console.log("Alerts: ", alertContext.alerts, alertContext.alerts.length);
  const location = useLocation();
  useEffect(() => {
    setTargetAlert(true);
    checkTarget();
    //eslint-disable-next-line
  }, [alertContext, location.pathname]);
  useEffect(() => {
    setAlertShown(false);
  }, [alertContext]);

  const checkTarget = () => {
    if (alertContext.alerts.length > 0) {
      if (alertContext.alerts[0].target) {
        const targetScreen = String(alertContext.alerts[0].target);
        const path = location.pathname;
        console.log(
          "Alert Loaction",
          path,
          targetScreen,
          targetScreen === path
        );
        if (targetScreen === location.pathname) {
          setTargetAlert(true);
          setAlertShown(true);
        } else {
          setTargetAlert(false);
          if (alertShown) {
            clearAlerts();
          }
        }
      }
    }
  };

  return (
    alertContext.alerts &&
    alertContext.alerts.length > 0 &&
    alertContext.alerts.map(
      (alert) =>
        targetAlert && (
          <div
            key={alert.id}
            className={`alert alert-${alert.type} notice-bar__alert`}
            role="alert"
            aria-relevant="all"
          >
            <i
              className={
                alert.type === "danger"
                  ? "fas fa-times-circle"
                  : "fas fa-info-circle"
              }
            />{" "}
            {alert.msg}
          </div>
        )
    )
  );
};

export default Alerts;
